/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenterRounded";
import CloudUploadRounded from "@material-ui/icons/CloudUploadRounded";

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Button, CompanyPage } from "../../../components/common";
import { useLocation, useNavigate } from "react-router-dom";
import appRoutes from "../../../routes/app.routes";
import { useSelector } from "react-redux";
import { rootReducersState } from "../../../reducers";
import UploadContact from "./upload";
import AddSubscriber from "./addSubscriber";

const AddContacts = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("manually");
  const [pathName, setPathName] = useState<string>("");
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const companySlug = sessionReducer.currentCompany.slug;
  const location=useLocation();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setValue((event.target as HTMLInputElement).value);

  const handleContinue = () => {
    if (value === "file") {
      navigate(appRoutes.uploadContact.generatePath(companySlug));
    } else {
      navigate(appRoutes.manuallyContact.generatePath(companySlug));
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

   useEffect(() => {
    const parts = location.pathname.split("/");
    setPathName(parts[4] || "");
  }, [location.pathname]);

  return (
    <>
      {pathName === "contact-manually" && (
        <AddSubscriber
          existingContact={null}
          setEditContact={() => {}}
          setModal={() => {}}
          setContactList={() => {}}
          onBack={handleBack}
        />
      )}
      {pathName === "contact-upload" && <UploadContact />}
      {!pathName && (
        <>
          <FormControl className="contact-form">
            <RadioGroup
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <div className="radio-wrapper">
                <div
                  className={`radio-card${value === "manually" ? " is-selected" : ""}`}
                  onClick={() => setValue("manually")}
                >
                  <div className="card-head">
                    <div className="icon">
                      <BusinessCenterIcon />
                    </div>
                    <FormControlLabel
                      value="manually"
                      control={<Radio color="primary" />}
                      label="Add Subscriber manually"
                      labelPlacement="start"
                      className="m-0"
                    />
                  </div>
                  <div className="card-body">
                    <p>
                      Add one subscriber at a time by entering their contact
                      details and assigning tags for better audience
                      segmentation.
                    </p>
                  </div>
                </div>
                <div
                  className={`radio-card${value === "file" ? " is-selected" : ""}`}
                  onClick={() => setValue("file")}
                >
                  <div className="card-head">
                    <div className="icon">
                      <CloudUploadRounded />
                    </div>
                    <FormControlLabel
                      value="file"
                      control={<Radio color="primary" />}
                      label="Upload a file"
                      labelPlacement="start"
                      className="m-0"
                    />
                  </div>
                  <div className="card-body">
                    <p>
                      Upload a CSV file to add multiple subscribers at once and
                      quickly build your contact list for upcoming campaigns.
                    </p>
                  </div>
                </div>
              </div>
            </RadioGroup>
          </FormControl>
          <CompanyPage.Footer>
            <CompanyPage.FooterActions>
              <Button onClick={handleContinue}>Continue</Button>
            </CompanyPage.FooterActions>
          </CompanyPage.Footer>
        </>
      )}
    </>
  );
};
export default AddContacts;
